import { defineStore } from 'pinia';

function arePlacesEqual(place1, place2) {
  return +Number(place1.lat).toFixed(3) === +Number(place2.lat).toFixed(3) &&
         +Number(place1.lon).toFixed(3) === +Number(place2.lon).toFixed(3);
}

export const usePlacesStore = defineStore('places', {
  state: () => ({
    starredPlaces: [],
  }),
  actions: {
    addPlace(place) {
      if (!this.isPlaceStarred(place)) {
        this.starredPlaces.push(place);
        this.savePlaces();
      }
    },
    removePlace(place) {
      this.starredPlaces = this.starredPlaces.filter(
        (p) => !arePlacesEqual(p, place)
      );
      this.savePlaces();
    },
    savePlaces() {
      localStorage.setItem('starredPlaces', JSON.stringify(this.starredPlaces));
    },
    loadPlaces() {
      const storedPlaces = localStorage.getItem('starredPlaces');
      if (storedPlaces) {
        this.starredPlaces = JSON.parse(storedPlaces);
      }
    },
  },
  getters: {
    isPlaceStarred: (state) => (place) => {
      return state.starredPlaces.some(
        (starredPlace) => arePlacesEqual(starredPlace, place)
      );
    },
  },
});